import gql from 'graphql-tag';

export const getStudentCourseModuleStudyPlan = gql`
  query getStudentStudyPlanTemplate(
    $courseId: Float!
    $moduleId: Float!
    $disciplineIds: [Float!]!
  ) {
    getStudentStudyPlanTemplate(
      courseId: $courseId
      moduleId: $moduleId
      disciplineIds: $disciplineIds
    ) {
      id
      name
      courseId
      moduleId
      eventId
      activities {
        id
        pedagogicalActivityId
        week
        courseId
        disciplineId
        moduleId
        playlistId
        startDateTime
      }
    }
  }
`;
